module.exports = __webpack_public_path__ + "img/google-play-badge_ja_equalised.4fae8d03.svg";